function handleClick(url) {
  window.open(url);
}

export default handleClick;
